import { usePaneLocation } from "@/hooks/pane-routing";

/** Template id from the open right-pane skill-template route, or null. */
export function useActiveSkillTemplateId(): string | null {
  const paneLocation = usePaneLocation("rightPane");
  const match = paneLocation?.pathname?.match(/^\/skill-templates\/([^/]+)/);
  return match?.[1] ?? null;
}
